<button class="small" mat-raised-button   color="primary" (click)="abrir_mailing()" > 
  <i class="fa fa-paper-plane-o" aria-hidden="adjuntar fichero" ></i>  &nbsp; Mailing
</button>